import React, { useState, useEffect } from 'react';
import NavBarButtons from "./NavBarButtons";
import {SaveOnResortStepBox} from './style';
import {useForm} from "../../_hooks/useForm";
import {useDispatch, useSelector} from "react-redux";
import {AlertError} from "../Login/style";
import 'react-toastify/dist/ReactToastify.css';

const SaveOnResortStep = (props) => {

    const {msgError} = useSelector(state => state.ui);
    const {email, firstName, lastName} = useSelector(state => state.repository.user);
    const [formValues, handleInputChange] = useForm({
        emailUser: email,
        password: ''
    });

    const {emailUser, password} = formValues;

    const [saveOnResort, setSaveOnResort] = useState({});

    useEffect(() => {
        setSaveOnResort({
            Email: emailUser,
            Password: password,
            FirstName: firstName,
            LastName: lastName,
            UserAccountTypeID: 5
        })
    }, [formValues]);

    return (
        <>
            <SaveOnResortStepBox>
                    <h2>Save on Resort Membership</h2>

                    <div className="row">
                        <div className="col_full">
                            {
                                msgError &&
                                <AlertError>
                                    {msgError}
                                </AlertError>
                            }

                            <div className="col_half divcenter">
                                <label htmlFor="login-form-email">User Email:</label>
                                <input type="text"
                                       id="emailUser"
                                       name="emailUser"
                                       value={emailUser}
                                       onChange={handleInputChange}
                                       className="form-control not-dark"/>
                            </div>

                            <div className="col_half divcenter">
                                <label htmlFor="login-form-email">User Password:</label>
                                <input type="password"
                                       id="password"
                                       name="password"
                                       value={password}
                                       onChange={handleInputChange}
                                       className="form-control not-dark"/>
                            </div>

                        </div>
                    </div>

                <NavBarButtons data={formValues} saveon={saveOnResort} previousStep={props.previousStep} nextStep={props.nextStep}
                               currentStep={props.currentStep}/>
            </SaveOnResortStepBox>
        </>
    );
};

export default SaveOnResortStep;
